import React, { useContext } from "react";
import * as API from "../../api";
import * as Yup from "yup";
import * as CONST from "../../helpers/Constants";
import { Formik, Form, Field } from "formik";
import KidneyFunctionTestSubForm from "./KidneyFunctionTestSubForm";
import { Settings } from "../../helpers/Contexts";
import { FormGroup, FormControl } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FieldError from "../../shared/FieldError";

const LastMeasurementForm = ({props, task, showDataEntry, setShowDataEntry}) => {
  let measurement = task.cpr.procedure_type;
  const settings = useContext(Settings);

  let measurementData = measurement == "Colon Cancer Screening"
      ? null
      : settings.quality_measurement_types.filter((i) => i.name == measurement)[0];

  const MeasurementSchema = Yup.object().shape({
    patient_id: Yup.number(),
    cpr_id: Yup.number(),
    quality_measurement_type_id: Yup.number().nullable(),
    value:
      CONST.KIDNEY_FUNCTION_REQUIRING_INPUT.includes(measurement) == true
        ? Yup.string().matches(/^\d{1,4}$/, "Valid format must be a number e.g. 30").required("Value for " + measurement + " is required")
        : measurement == "Colon Cancer Screening"
        ? Yup.bool()
        : measurement == "Total Cholesterol"
        ? Yup.string()
            .min(1, "Minimum 1 number characters or more")
            .max(3, "Maximum 3 number characters")
            .matches(/^\d{2,3}$/, "Total Cholesterol must be an integer e.g. 159")
            .required("Value for " + measurement + " is required")
        : measurement == "LDL Cholesterol"
        ? Yup.string()
            .min(1, "Minimum 1 number characters or more")
            .max(3, "Maximum 3 number characters")
            .matches(/^\d{2,3}$/, "LDL Cholesterol must be an integer e.g. 139")
            .required("Value for " + measurement + " is required")
        : measurement == "HbA1c"
        ? Yup.string()
            .matches(/^\d*\.{1}\d*$/, "Value must be a floating point (decimal) e.g. 5.23")
            .required("Value for " + measurement + " is required")
        : Yup.mixed(),

    measured_at_date: Yup.date(),
    date: Yup.string().required("Measurement date is required."),
    attending_provider: Yup.string().required("Attending provider is required"),
    document: Yup.mixed().required("A document is required"),
  });

  return (
    <Formik
      initialValues={{
        patient_id: task.patient.uid,
        cpr_id: task.cpr.id,
        procedure_type: measurement,
        quality_measurement_type_id:
          measurement == "Colon Cancer Screening"
            ? ""
            : measurementData
            ? measurementData.id
            : "",
        value:
          (measurement !== "Colon Cancer Screening" && measurement !== 'Kidney Function Test') &&
          measurementData &&
          measurementData.value_type == "boolean"
            ? true
            : "",
        measured_at_date: "",
        date: "",
        attending_provider: task.cpr.procedure_type == "Cologuard" ? CONST.DEFAULT_COLOGUARD_ATTENDING_PROVIDER : "",
      }}
      validationSchema={MeasurementSchema}
      validateOnChange={true}
      onSubmit={async (values) => {
        let isAwv = task.cpr.procedure_type == 'Annual Wellness Visit';
        let params = {
          patient_id: values.patient_id,
          measured_at_date: values.measured_at_date,
          cpr_id: values.cpr_id,
          attending_provider: values.attending_provider,
          document: values.document,
        };

        let data = new FormData();
        let data2 = null;

        if (values.quality_measurement_type_id) {
          params['value'] = values.value
          params['quality_measurement_type_id'] = values.quality_measurement_type_id
          for (var i in params) {
            data.append(`quality_measurement[${i}]`, params[i]);
          }
        }

        // For Kidney Function Tests, the KidneyFunctionTestSubForm allows up to two values to be submitted.
        // For example, we submit a Urine Protein Screening with a Kidney Function Test (EGFR),
        // or a Kidney Function Test (Microalbumin/Creatinine Ratio) with a Kidney Function Test (EGFR).
        // We store the EGFR value in value_2
        if (values.quality_measurement_type_id_2) {
          data2 = new FormData();

          params['value'] = values.value_2
          params['quality_measurement_type_id'] = values.quality_measurement_type_id_2
          for (var i in params) {
            data2.append(`quality_measurement[${i}]`, params[i]);
          }
        }

        data.append("event", "cpr_completed");

        await API.postQualityMeasurement(data)
          .then(async (res) => {

            if (data2 != null) {
              let response = await API.postQualityMeasurement(data2);

              if (response) {
                return task.formHandler({ task: { id: task.id, status: isAwv ? 'open' : 'closed' } });
              }
            } else {
              return task.formHandler({ task: { id: task.id, status: isAwv ? 'open' : 'closed' } });
            }
          })
          .catch((err) => {
            console.log("Error @ API[updateQualityMeasurement]", err);
            return { error: err };
          });
      }}
    >
      {({ values, errors, setFieldValue, initialValues, isSubmitting }) => {
        return (
          <>
          {!showDataEntry && (<Form>
                {
                  task.cpr.procedure_type == "Kidney Function Test" ? (
                    <KidneyFunctionTestSubForm setFieldValue={setFieldValue} values={values} />
                  ) : task.cpr.procedure_type == "Colon Cancer Screening" ? (
                  <>
                    <label>Procedure Type</label>
                    <select
                      className="time-selector"
                      placeholder="Select procedure type"
                      name="procedure_type"
                      onChange={(e) => {
                        setFieldValue(
                          "quality_measurement_type_id",
                          settings.colon_cancer_screening_options.filter(
                            (i) => i.label == e.target.value
                          )[0].quality_measurement_type_id
                        );
                        setFieldValue("value", true);
                        setFieldValue("procedure_type", e.target.value);
                        if (e.target.value == "Cologuard") {
                          setFieldValue("attending_provider", CONST.DEFAULT_COLOGUARD_ATTENDING_PROVIDER);
                        } else {
                          setFieldValue("attending_provider", "");
                        }
                      }}
                    >
                      {!values.quality_measurement_type_id && (
                        <option value={""}>Select procedure type</option>
                      )}
                      {settings.colon_cancer_screening_options.map((t, idx) => (
                        <option key={idx} value={t.label}>
                          {t.label}
                        </option>
                      ))}
                    </select>
                  </>
                ) : (
                  <>
                    {[
                      "LDL Cholesterol",
                      "Total Cholesterol",
                      "HbA1c",
                      "Kidney Function Test (Microalbumin/Creatinine Ratio)",
                      'Kidney Function Test (eGFR)',
                    ].includes(measurement) ? (
                      <>
                        <label>{measurement}</label>
                        <input
                          className="default"
                          name="value"
                          onChange={(e) => setFieldValue("value", e.target.value)}
                        />
                        {errors.value ? <FieldError error={errors.value} /> : null}
                      </>
                    ) : (
                      <>
                        {measurementData && measurementData.value_type == "boolean" && (
                          <select disabled>
                            <option>{measurement}</option>
                          </select>
                        )}
                      </>
                    )}
                  </>
                )}
                <label>Attending Provider</label>
                <input
                  className="default"
                  name="attending_provider"
                  onChange={(e) => setFieldValue("attending_provider", e.target.value)}
                  value={
                    values.procedure_type == "Cologuard"
                      ? CONST.DEFAULT_COLOGUARD_ATTENDING_PROVIDER
                      : values.attending_provider
                  }
                />
                {errors.attending_provider ? (
                  <FieldError error={errors.attending_provider} />
                ) : null}
                <label>Measurement date</label>
                <div className={"flex datefield-wrapper full-width"}>
                  <Field name="date">
                    {({ field, meta }) => {
                      return (
                        <>
                          <ReactDatePicker
                            {...field}
                            autoComplete="off"
                            className="datepicker"
                            maxDate={new Date()}
                            dateFromat={"YYYY-MM-dd"}
                            onChange={(date) => {
                              setFieldValue(
                                "measured_at_date",
                                new Date(date).toLocaleDateString()
                              );
                              setFieldValue("date", date.toISOString().slice(0, 10));
                            }}
                          />
                        </>
                      );
                    }}
                  </Field>
                </div>
                {errors.date ? <FieldError error={errors.date} /> : null}
                <label>Attach Results/Visit Summary (If Available)</label>
                <FormGroup controlId="formFile" className="mb-3">
                  <FormControl
                    type="file"
                    onChange={(e) => setFieldValue("document", e.target.files[0])}
                  />
                </FormGroup>
                {errors.document ? <FieldError error={errors.document} /> : null}

                <button className="check accent-bg pt2" type="submit" disabled={isSubmitting}>
                  Submit
                </button>
              </Form>)
            }
          </>
        );
      }}
    </Formik>
  );
};

export default LastMeasurementForm;
